import { useCallback, useEffect } from 'react';
import { skipTrialChoiceFeature } from 'core/feature-flags/config/skipTrialChoiceFeature';
import { useFeatureFlags } from 'core/feature-flags/hooks';
import { ScreenAttributes, ScreenType } from 'core/flow/entities';
import { useOffers } from 'core/offers/hooks';

type GetScreenAttributes = (id: string) => ScreenAttributes;

export const useTrialChoiceSkip = (
  getScreenAttributes: GetScreenAttributes,
): GetScreenAttributes => {
  const featureFlags = useFeatureFlags();

  const { defaultOffers, updateOffer } = useOffers();

  const shouldSkipTrialChoice = !!featureFlags.getFeatureValue(skipTrialChoiceFeature);

  useEffect(() => {
    if (!shouldSkipTrialChoice || !defaultOffers[0]) return;

    updateOffer(defaultOffers[0]);
  }, [shouldSkipTrialChoice, defaultOffers, updateOffer]);

  return useCallback(
    (id: string) => {
      const attributes = getScreenAttributes(id);

      if (!shouldSkipTrialChoice || !attributes.next) return attributes;

      const nextAttributes = getScreenAttributes(attributes.next);

      if (!nextAttributes.screenType.startsWith(ScreenType.TRIAL_CHOICE)) return attributes;

      return { ...attributes, next: nextAttributes.next };
    },
    [getScreenAttributes, shouldSkipTrialChoice],
  );
};
